import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
/* eslint-disable no-unused-vars */
import { TweenMax, TimelineMax, Power0 } from 'gsap/TweenMax'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'

import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import '@comp/business_category/business_category.scss'

import './style.scss'
import { trackSection } from '@/scripts/ga'

function fetchFeaturedNews (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}feature_news`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            return cb(null, msg)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function fetchFeaturedCompany (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}feature_company`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            return cb(null, msg)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function dateFormat (d) {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    const date = new Date(d)

    return `${months[date.getMonth()]} ${date.getDate()}`
}

$(() => {
    trackSection('About Us')

    const controller = new ScrollMagic.Controller()
    const animation1 = new TimelineMax()
    animation1.addLabel('point')
    const tween1 = TweenMax.fromTo(
        '.e-list-white', 1,
        {
            transform: 'translateY(0px)'
        },
        {
            transform: 'translateY(-1212px)',
            ease: Power0.easeNone
        }, 'point'
    )
    const tween2 = TweenMax.fromTo(
        '.e-list-transparent', 1,
        {
            transform: 'translateY(0px)'
        },
        {
            transform: 'translateY(-1212px)',
            ease: Power0.easeNone
        }, 'point'
    )
    animation1.add([tween1, tween2])

    /* eslint-disable no-new */
    new ScrollMagic.Scene({
        triggerElement: ' #e-list-sec',
        triggerHook: 'onLeave',
        duration: '200%'
    })
        .setPin('#e-list-sec')
        .setTween(animation1)
        .addTo(controller)

    fetchFeaturedCompany(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }
        let partenerList = ''
        result.forEach((partener, index) => {
            partenerList += `
            <div class="item-wrap">
                <a class="partener-card-wrap track-btn" href="ecosystem_detail.html?id=${partener.id}" data-track="Ecosystem #${partener.name}" style="display: block;">
                    <div class="partener-img-wrap tilt-link" style="background-image: url('${partener.cover}')"></div>
                    <div class="partener-label-wrap left">
                        <div class="icon" style="background-image: url('${partener.logo}')"></div>
                        <h6 class="title">${partener.name}</h6>
                    </div>
                </a>
            </div>
            `
        })

        $('#partener-list-body').html(partenerList)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })
    })

    fetchFeaturedNews(function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }
        let newsList = ''
        result.forEach((news) => {
            newsList += `
            <div class="col-md-4 col-sm-7 col-xs-12 slideup space-wrap">
                <a href="news.html?id=${news.id}" class="insight-block link-wrap track-btn" data-track="News #${news.title}">
                    <div class="ib-img tilt-link bg-hover">
                        <div class="ib-img-inner" style="background-image: url('${news.cover}')"></div>
                    </div>
                    <div class="ib-content ext">
                        <h5 class="ib-title">
                            <span class="ellipsis">${news.title}</span>
                        </h5>
                        <div class="date-wrap">
                            <b>${dateFormat(new Date(news.createdAt))}</b>
                        </div>
                    </div>
                </a>
            </div>
            `
        })

        $('#news-list-row').html(newsList)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })
    })

    scrollbar.init()
})
